import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { Input, Textarea } from '@tmapy/style-guide';
export class TextForm extends React.PureComponent {
    render() {
        return this.props.isLong ? (_jsx(Textarea, { value: this.props.content, onChange: this.props.onChange })) : (_jsx(Input, { value: this.props.content, onChange: this.props.onChange }));
    }
}
//# sourceMappingURL=form.js.map